import React from "react";
import ReactDOM from 'react-dom/client';
import App from "./App.js";
import {
  isChatbotMaintenanceMode,
  MAINTENANCE_PAGE_PATH,
} from "./config/features";

import { ThemeProvider } from '@mui/styles'; // using makeStyles? Keep this
import { createTheme } from '@mui/material/styles';
import "./index.css"; // ← make sure global styles are imported here

const theme = createTheme();

// Global capture listener to gate chatbot behind auth without modifying the widget
if (typeof document !== 'undefined') {
  const handler = (e) => {
    try {
      const target = e.target;
      // Look up the ancestry to find the chatbot floating button by class
      const isChatbotButton = (el) => {
        if (!el || !el.classList) return false;
        return el.classList.contains('chatbot-button') || el.classList.contains('chatbot-button-blink');
      };
      let el = target;
      let found = false;
      for (let i = 0; i < 5 && el; i++) { // limit traversal a bit
        if (isChatbotButton(el)) { found = true; break; }
        el = el.parentElement;
      }
      const authed = localStorage.getItem('isAuthenticated') === 'true';
      if (found && !authed) {
        // Block the click and open the auth modal globally
        e.preventDefault();
        e.stopPropagation();
        try {
          if (isChatbotMaintenanceMode) {
            if (window.location.pathname !== MAINTENANCE_PAGE_PATH) {
              window.location.assign(MAINTENANCE_PAGE_PATH);
            }
          } else {
            window.dispatchEvent(new CustomEvent('open-auth-modal', { detail: { view: 'signIn' } }));
          }
        } catch (_) {}
      }
    } catch (_) {}
  };
  document.addEventListener('click', handler, true); // capture phase
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
